export const FETCH_PAGE = 'FETCH_PAGE';
export type FETCH_PAGE = typeof FETCH_PAGE;

export const USER_DATA = 'USER_DATA';
export type USER_DATA = typeof USER_DATA;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/constants.ts